import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import {
  Button,
  Drawer,
  Popconfirm,
  Space,
  Tabs,
  Tag,
  Tooltip,
  Typography,
} from 'antd';
import { AccessControl } from 'components/AccessControl';
import { DELETE_CONFIRM } from 'constants/alerts';
import { useEffect, useState } from 'react';
import { RowBlock } from 'ui/RowBlock';
import { SectionTitle } from 'ui/SectionTitle';
import { checkField, formatDate } from 'utils';
import {
  pushType,
  sendingFrequency,
} from 'utils/handbooks/pushManagerHandbooks';
import { renderDate } from '../PushNotificationTable';
import { PushNotificationSendingsTable } from './PushNotificationSendingsTable';

function PushNotificationDetail({
  activeRecord,
  isActive,
  onClose,
  onEdit,
  onDelete,
}) {
  const [activeTab, setActiveTab] = useState('push_info');

  useEffect(() => {
    return () => setActiveTab('push_info');
  }, [activeRecord]);

  return (
    <Drawer
      width="50%"
      title={activeRecord?.title}
      visible={isActive}
      onClose={onClose}
      extra={
        <Space>
          <AccessControl pageId="segments" action="update">
            <Tooltip placement="bottomLeft" title="Редактировать">
              <Button type="default" onClick={onEdit} icon={<EditOutlined />} />
            </Tooltip>
          </AccessControl>

          <AccessControl pageId="pushNotification" action="delete">
            <Popconfirm
              title={DELETE_CONFIRM}
              placement="bottomLeft"
              onConfirm={onDelete}
              okText="Да"
              cancelText="Нет"
            >
              <Button type="default" danger icon={<DeleteOutlined />} />
            </Popconfirm>
          </AccessControl>
        </Space>
      }
    >
      <Tabs
        centered
        activeKey={activeTab}
        onChange={(tab) => setActiveTab(tab)}
      >
        <Tabs.TabPane tab="Общая информация" key="push_info">
          <SectionTitle>Уведомление</SectionTitle>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Название:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.title)}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Заголовок:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.header)}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Текст:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.text)}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Ссылка на страницу:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.url)}
            </Typography.Text>
          </RowBlock>

          <SectionTitle>Аудитория</SectionTitle>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Сегмент:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(
                activeRecord?.segments.map(({ id, title }) => (
                  <Tag key={id}>{title}</Tag>
                ))
              )}
            </Typography.Text>
          </RowBlock>

          <SectionTitle>Время</SectionTitle>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Тип:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(pushType[activeRecord?.type])}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Частота отправки:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(sendingFrequency[activeRecord?.send_frequency])}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Дата отправки:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {renderDate(activeRecord?.date_send, activeRecord)}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Время отправки:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(activeRecord?.time_send)}
            </Typography.Text>
          </RowBlock>

          <RowBlock>
            <Typography.Text type="secondary" className="column-block-right">
              Дата окончание:
            </Typography.Text>
            <Typography.Text className="column-block-left">
              {checkField(
                activeRecord?.active_until &&
                  formatDate(activeRecord?.active_until)
              )}
            </Typography.Text>
          </RowBlock>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Отправки" key="push_notifications">
          <PushNotificationSendingsTable
            isActive={activeTab === 'push_notifications'}
            pushNotificationId={activeRecord?.id}
          />
        </Tabs.TabPane>
      </Tabs>
    </Drawer>
  );
}

export { PushNotificationDetail };
